<template>
    <div @click="click">
        <slot></slot>
    </div>
</template>

<script>
export default {
    methods: {
        click() {
            this.$emit('click')
        }
    }
}
</script>
